import { render, staticRenderFns } from "./xc-base_table.vue?vue&type=template&id=c58bb688&scoped=true"
import script from "./xc-base_table.vue?vue&type=script&lang=js"
export * from "./xc-base_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58bb688",
  null
  
)

export default component.exports